import React from 'react'
import MixedContentPreview from '../UiElements/MixedContentPreview'
import ExplainSessionView from './ExplainSessionView'

const noop = () => {}

/**
 * Off-screen copy of the exercise, used only when the live exercise is not
 * mounted (the student is on another Study Helper tab). The page picture is
 * taken from the visible screen; this sheet is what makes the emailed exercise
 * match the cards and math the student sees in the app.
 */
const ReportExerciseSheet = ({
  exercise,
  explainSession,
  explainStepIndex,
  groupedSolution = false
}) => {
  if (!exercise) return null

  const explainView = exercise.kind === 'explain' && explainSession ? (
    <ExplainSessionView
      question={explainSession.question || exercise.questionText}
      topic={explainSession.topic}
      steps={explainSession.steps || []}
      finalAnswer={explainSession.finalAnswer || ''}
      finalVisual={explainSession.finalVisual || null}
      currentStepIndex={explainStepIndex}
      explanationText={exercise.stepText}
      askEnabled={false}
      speechSupported={false}
      ttsEnabled={false}
      finishing={false}
      completed={false}
      hideControls
      liveSession
      groupedSolution={groupedSolution}
      reportAnchor
      onPrevious={noop}
      onNext={noop}
      onFinish={noop}
      onAsk={noop}
      onToggleTts={noop}
      onChangeTtsVoice={noop}
      onStartOver={noop}
      onRefresh={noop}
    />
  ) : (
    <div data-report-exercise-fallback="true">
      <article className="student-report-exercise-card">
        <h3>Question</h3>
        <MixedContentPreview content={exercise.questionText} fontSize="1.5rem" />
      </article>
      {exercise.answerText ? (
        <article className="student-report-exercise-card">
          <h3>Your Answer</h3>
          <MixedContentPreview content={exercise.answerText} fontSize="1.5rem" />
        </article>
      ) : null}
      {exercise.feedbackText ? (
        <article className="student-report-exercise-card">
          <h3>Feedback</h3>
          <p>{exercise.feedbackText}</p>
        </article>
      ) : null}
      {exercise.stepText ? (
        <article className="student-report-exercise-card">
          <h3>
            {exercise.stepCount
              ? `Step ${exercise.stepIndex + 1} of ${exercise.stepCount}`
              : 'Step'}
          </h3>
          <MixedContentPreview content={exercise.stepText} fontSize="1.15rem" />
        </article>
      ) : null}
    </div>
  )

  return (
    <div className="student-report-exercise-sheet" aria-hidden="true">
      {explainView}
    </div>
  )
}

export default ReportExerciseSheet
